<template>
  <span class="block" :style="{height:height+'px'}">
    <slot>{{title}}</slot>
  </span>
</template>

<script>
  export default{
    props:{
      data:{
        type:Array,
        default(){
          return [
          ]
        }
      },
      height:{
        style:Number
      }
    },
    data(){
      return {
        title:''
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .block{
   width: 415px;
   display: inline-block;
   background: #002258;
   // background: rgba(0,15,53,0.5);
   box-shadow: 0px 1px 9px 0px rgba(57, 129, 211, 0.28);
   border-radius: 4px;
   opacity: 0.95;
   border: 1px solid rgba(61, 155, 212, 0.39);
   padding:10px;
   margin-top:5px;
   height: 28vh;
   overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/block.vue